import React, { useState, useEffect } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import authService from '../../services/authService';
import '../../styles/Auth.css';
import Logo from '../../assets/Logo.png';

const ChangePassword = () => {
    const [formData, setFormData] = useState({
        newPassword: '',
        confirmPassword: ''
    });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    
    const email = searchParams.get('email');
    const otp = searchParams.get('otp');

    useEffect(() => {
        if (!email || !otp) {
            navigate('/forgot-password');
        }
    }, [email, otp, navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.newPassword) {
            newErrors.newPassword = 'New password is required';
        } else if (formData.newPassword.length < 6) {
            newErrors.newPassword = 'Password must be at least 6 characters';
        }

        if (!formData.confirmPassword) {
            newErrors.confirmPassword = 'Please confirm your password';
        } else if (formData.newPassword !== formData.confirmPassword) {
            newErrors.confirmPassword = 'Passwords do not match';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validateForm()) {
            return;
        }

        setLoading(true);
        try {
            await authService.changePassword(email, otp, formData.newPassword);
            toast.success('Password changed successfully!');
            setSuccess(true);
        } catch (error) {
            toast.error(error.message || 'Failed to change password. Please try again.');
            setErrors({
                submit: error.message || 'Failed to change password. Please try again.'
            });
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <div className="auth-container">
                <div className="auth-card">
                    <div className="auth-logo">
                        <img src={Logo} alt="Ginni Fashion Studio" />
                    </div>
                    
                    <h1 className="auth-title">Password Changed!</h1>
                    <p className="auth-subtitle">
                        Your password has been successfully changed.
                    </p>

                    <div className="success-message" style={{ textAlign: 'center', marginBottom: '20px' }}>
                        You can now sign in with your new password.
                    </div>

                    <Link to="/login">
                        <button className="auth-button">
                            Sign In
                        </button>
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className="auth-container">
            <div className="auth-card">
                <div className="auth-logo">
                    <img src={Logo} alt="Ginni Fashion Studio" />
                </div>
                
                <h1 className="auth-title">Create New Password</h1>
                <p className="auth-subtitle">
                    Enter your new password below
                </p>

                <form onSubmit={handleSubmit} autoComplete="off">
                    <div className="form-group">
                        <input
                            type="password"
                            name="newPassword"
                            value={formData.newPassword}
                            onChange={handleChange}
                            className={`form-input ${errors.newPassword ? 'error' : ''}`}
                            placeholder="New Password"
                            autoComplete="off"
                        />
                        {errors.newPassword && (
                            <div className="error-message">{errors.newPassword}</div>
                        )}
                    </div>

                    <div className="form-group">
                        <input
                            type="password"
                            name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            className={`form-input ${errors.confirmPassword ? 'error' : ''}`}
                            placeholder="Confirm New Password"
                            autoComplete="off"
                        />
                        {errors.confirmPassword && (
                            <div className="error-message">{errors.confirmPassword}</div>
                        )}
                    </div>

                    {errors.submit && (
                        <div className="error-message" style={{ textAlign: 'center', marginBottom: '15px' }}>
                            {errors.submit}
                        </div>
                    )}

                    <button 
                        type="submit" 
                        className="auth-button"
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <span className="loading-spinner"></span>
                                Changing Password...
                            </>
                        ) : (
                            'Change Password'
                        )}
                    </button>
                </form>

                <div className="auth-link">
                    <Link to="/login">Back to Sign In</Link>
                </div>
            </div>
        </div>
    );
};

export default ChangePassword;